// Order History Constants
export const STATUS_OPTIONS = [
  { label: "All Status", value: "" },
  { label: "Pending", value: "pending" },
  { label: "Accept", value: "accept" },
  { label: "Completed", value: "completed" },
  { label: "Delivered", value: "delivered" },
  { label: "Reject", value: "reject" },
];

export const ORDER_TYPE_ALL = { label: "All Order Types", value: "" };

export const TABLE_ROWS_PER_PAGE = 10;
 export const REPAIR_BLOCKED_STATUSES = [
  "out for delivery",
  "completed",
  "reject",
];
